<template>
  <div>
    <VipHeaderCompose />
    <div id="body">
      <div class="compose show-model">
        <ComposeLeft></ComposeLeft>
        <div class="compose_main">
          <div class="wrapper">
            <ComposeSearch
              :folderParentId="0"
              @refreshReportList="getUserReportList"
            ></ComposeSearch>
            <!-- <div class="inner-tabs">
              <el-tabs>
                <el-tab-pane label="全部报告"></el-tab-pane>
                <el-tab-pane label="我创建的"></el-tab-pane>
                <el-tab-pane label="已收藏的"></el-tab-pane>
                <el-tab-pane label="已归档的"></el-tab-pane>
              </el-tabs>
            </div> -->
            <div class="i-box">
              <div class="i-box_title">
                <h4>最近创作</h4>
              </div>
              <div class="i-box_content">
                <div class="report-list">
                  <el-skeleton :count="4" animated :loading="userReportLoading">
                    <template slot="template">
                      <div class="list-item">
                        <div class="pic">
                          <el-skeleton-item variant="image" />
                        </div>
                        <div class="title">
                          <el-skeleton-item variant="h2" />
                        </div>
                        <div class="time">
                          <el-skeleton-item variant="text" />
                        </div>
                      </div>
                    </template>
                    <template>
                      <div
                        class="list-item"
                        v-for="(item, index) in userReportList"
                        :key="index"
                      >
                        <!-- <div class="sel">
                          <el-checkbox label=""></el-checkbox>
                        </div> -->
                        <div class="pic">
                          <a
                            :href="'/console/editor?id=' + item.id"
                            target="_blank"
                          >
                            <el-image
                              :src="require('@/assets/images/sample-pic7.png')"
                            ></el-image>
                          </a>
                        </div>
                        <div class="type">
                          <i class="icon-type-w"></i>
                        </div>
                        <div class="title">{{ item.title }}</div>
                        <div class="time">
                          {{
                            dateFormat(item.createTime, "YYYY-MM-DD HH:mm:ss")
                          }}
                        </div>
                        <div class="op">
                          <el-button size="small" circle
                            ><img src="~@/assets/images/icon-menu.png"
                          /></el-button>
                          <div class="op-dropdown-menu">
                            <ul>
                              <!-- <li>
                                <img
                                  src="~@/assets/images/icon-dropdown-i1.png"
                                  alt=""
                                />预览
                              </li>
                              <li>
                                <img
                                  src="~@/assets/images/icon-dropdown-i2.png"
                                  alt=""
                                />克隆
                              </li>
                              <li>
                                <img
                                  src="~@/assets/images/icon-dropdown-i3.png"
                                  alt=""
                                />分享
                              </li> -->

                              <li
                                @click="
                                  handleFolderTreeDialog(
                                    1,
                                    item.folderId,
                                    item.id
                                  )
                                "
                              >
                                <img
                                  src="~@/assets/images/icon-dropdown-i4.png"
                                  alt=""
                                />复制到
                              </li>
                              <li
                                @click="
                                  handleFolderTreeDialog(
                                    0,
                                    item.folderId,
                                    item.id
                                  )
                                "
                              >
                                <img
                                  src="~@/assets/images/icon-dropdown-i5.png"
                                  alt=""
                                />移动到
                              </li>
                              <li @click="handleDelUserReport(item.id)">
                                <img
                                  src="~@/assets/images/icon-dropdown-i6.png"
                                  alt=""
                                />删除
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-skeleton>
                </div>
              </div>
            </div>
            <div class="i-box">
              <div class="i-box_title">
                <h4>为您推荐</h4>
              </div>
              <div class="i-box_content">
                <div
                  class="article-list"
                  v-infinite-scroll="recommendNextPage"
                  infinite-scroll-disabled="disabled"
                >
                  <el-skeleton :loading="recommendLoading" :count="4" animated>
                    <template slot="template">
                      <div class="list-item">
                        <div class="title">
                          <el-skeleton-item
                            variant="h2"
                            style="width: 116px; margin-right: 15px"
                          />
                          <el-skeleton-item variant="h2" style="width: 80%" />
                        </div>
                        <div class="intro">
                          <el-skeleton-item />
                          <el-skeleton-item style="width: 60%" />
                        </div>
                        <div class="info">
                          <span class="t">
                            <el-skeleton-item
                              variant="text"
                              style="width: 100px"
                            />
                          </span>
                          <span class="o">
                            <el-skeleton-item
                              variant="text"
                              style="width: 100px"
                            />
                          </span>
                          <span class="b">
                            <el-skeleton-item
                              variant="text"
                              style="width: 100px"
                            />
                          </span>
                        </div>
                      </div>
                    </template>
                    <template v-for="(item, index) in recommendList">
                      <div
                        class="list-item"
                        v-if="item.type === 'report'"
                        :key="index"
                      >
                        <div class="title">
                          <span class="type" v-if="item.industryFirst">
                            {{ item.industryFirst }}
                          </span>
                          <a
                            href="javascript:;"
                            v-if="!item.pdfPath"
                            v-html="item.title"
                          >
                          </a>
                          <a
                            :href="
                              '/report/read?id=' +
                              item.id +
                              '&type=0&title=' +
                              encodeURIComponent(
                                item.title.replace(/(<([^>]+)>)/gi, '')
                              )
                            "
                            target="_blank"
                            v-else-if="
                              item.pdfPath.substring(
                                item.pdfPath.lastIndexOf('.')
                              ) === '.pdf'
                            "
                            v-html="item.title"
                          >
                          </a>
                          <a
                            v-else
                            href="javascript:;"
                            @click="
                              handleDownload(
                                item.id,
                                item.title.replace(/(<([^>]+)>)/gi, ''),
                                item.pdfPath.substring(
                                  item.pdfPath.lastIndexOf('.')
                                )
                              )
                            "
                            v-html="item.title"
                          >
                          </a>
                        </div>

                        <dd
                          class="pics"
                          v-if="item.picList && item.picList.length > 0"
                        >
                          <swiper ref="pic" :options="picSwiper">
                            <swiper-slide
                              v-for="(pic, index) in item.picList"
                              :key="index"
                            >
                              <label>
                                <!-- {{ index + 1 }}． -->
                                {{
                                  pic.title.replace(
                                    /[图表]+?[\d-]{0,6}[:：\s\.]+/g,
                                    ""
                                  )
                                }}
                              </label>
                              <el-image
                                :src="pic.src"
                                @click="handlePicShow(item, index)"
                              >
                                <div slot="error" style="margin-top: -120px">
                                  <i class="el-icon-picture-outline"></i>
                                </div>
                              </el-image>
                            </swiper-slide>
                          </swiper>
                        </dd>

                        <dd class="info">
                          <span class="t" v-if="item.date">
                            <img src="~@/assets/images/icon-time.png" alt="" />
                            {{ dateFormat(item.date, "YYYY-MM-DD") }}
                          </span>
                          <span
                            class="o"
                            v-if="
                              item.institution && item.institution.length > 0
                            "
                          >
                            <img src="~@/assets/images/icon-from.png" alt="" />
                            <span
                              v-for="(institution, index) in item.institution"
                              :key="index"
                              v-html="institution"
                            ></span>
                          </span>
                          <span
                            class="u"
                            v-if="item.author && item.author.length > 0"
                          >
                            <img src="~@/assets/images/icon-user.png" alt="" />
                            <el-tooltip placement="top" effect="light">
                              <div
                                slot="content"
                                v-html="item.author.join(', ')"
                              ></div>
                              <span
                                v-html="
                                  item.author[0] +
                                  (item.author.length > 1 ? ' ...' : '')
                                "
                              ></span>
                            </el-tooltip>
                          </span>
                          <span class="p" v-if="item.pages">
                            <img src="~@/assets/images/icon-page.png" alt="" />
                            {{ item.pages }}页
                          </span>
                        </dd>
                        <!-- <div class="hot">25486</div> -->

                        <div class="op">
                          <el-button
                            circle
                            icon="el-icon-close"
                            @click="handleRecommendClose(item)"
                          ></el-button>
                        </div>
                      </div>

                      <div
                        class="list-item"
                        v-if="item.type === 'article'"
                        :key="index"
                      >
                        <div class="title">
                          <span class="type">期刊文章</span>
                          <a
                            :href="
                              item.showDown
                                ? '/console/read?id=' +
                                  item.id +
                                  '&type=0&title=' +
                                  item.title
                                : 'javascript:void(0)'
                            "
                            target="_blank"
                          >
                            {{ item.title }}
                          </a>
                        </div>

                        <div class="intro">
                          {{ item.abstract }}
                        </div>
                        <div class="info">
                          <span class="t">
                            <img src="~@/assets/images/icon-time.png" alt="" />
                            {{ item.year }}年
                          </span>
                          <span class="o">
                            <img src="~@/assets/images/icon-from.png" alt="" />
                            {{ item.organization.join(", ") }}
                          </span>
                          <span class="u">
                            <img src="~@/assets/images/icon-user.png" alt="" />
                            <el-tooltip placement="top" effect="light">
                              <div
                                slot="content"
                                v-html="item.writer.join(', ')"
                              ></div>
                              <span
                                v-html="
                                  item.writer[0] +
                                  (item.writer.length > 1 ? ' ...' : '')
                                "
                              ></span>
                            </el-tooltip>
                          </span>
                          <span class="p" v-if="item.paginalumber">
                            <img src="~@/assets/images/icon-page.png" alt="" />
                            {{ item.paginalumber }}页
                          </span>
                        </div>
                        <!-- <div class="hot">25486</div> -->

                        <div class="op">
                          <el-button
                            circle
                            icon="el-icon-close"
                            @click="handleRecommendClose(item)"
                          ></el-button>
                        </div>
                      </div>

                      <div
                        class="list-item"
                        v-if="item.type === 'patent'"
                        :key="index"
                      >
                        <div class="title">
                          <span class="type t0">
                            {{ item.currLegalStatus }}
                          </span>
                          <span class="type">{{ item.pattypeText }}</span>
                          <a
                            :href="
                              '/console/read?id=' +
                              item.pubnumber[0] +
                              '&type=1&title=' +
                              clearHtml(item.title)
                            "
                            target="_blank"
                          >
                            {{ clearHtml(item.title) }}
                          </a>
                        </div>

                        <div class="intro">
                          <span v-text="clearHtml(item.abs)"></span>
                        </div>
                        <div class="info">
                          <span class="t">
                            <img src="~@/assets/images/icon-time.png" alt="" />
                            {{ dateFormat(item.pubdate, "YYYY-MM-DD") }}
                          </span>
                          <span class="o">
                            <img src="~@/assets/images/icon-from.png" alt="" />
                            {{ clearHtml(item.applicantname.join(" ")) }}
                          </span>
                          <span
                            class="u"
                            v-if="
                              item.inventorname && item.inventorname.length > 0
                            "
                          >
                            <img src="~@/assets/images/icon-user.png" alt="" />
                            <el-tooltip placement="top" effect="light">
                              <div
                                slot="content"
                                v-html="clearHtml(item.inventorname.join(', '))"
                              ></div>
                              <span
                                v-html="
                                  item.inventorname[0] +
                                  (item.inventorname.length > 1 ? ' ...' : '')
                                "
                              ></span>
                            </el-tooltip>
                          </span>
                        </div>
                        <!-- <div class="hot">25486</div> -->

                        <div class="op">
                          <el-button
                            circle
                            icon="el-icon-close"
                            @click="handleRecommendClose(item)"
                          ></el-button>
                        </div>
                      </div>

                      <div
                        class="list-item"
                        v-if="item.type === 'policy'"
                        :key="index"
                      >
                        <div class="title">
                          <span class="type">产业政策</span>
                          <a
                            :href="'/policy/detail?id=' + item._id"
                            target="_blank"
                            v-html="item.title"
                          ></a>
                        </div>

                        <div class="intro">
                          {{ cutstring(clearHtml(item.fulltext), 580) }}
                        </div>
                        <div class="info">
                          <span class="t">
                            <img src="~@/assets/images/icon-time.png" alt="" />
                            {{ dateFormat(item.publish_time, "YYYY-MM-DD") }}
                          </span>
                          <span class="u">
                            <template
                              v-if="item.organ && item.organ.length > 0"
                            >
                              <img src="~@/assets/images/icon-from.png" />
                              <el-tooltip placement="top" effect="light">
                                <div
                                  slot="content"
                                  v-html="item.organ.split(';').join(', ')"
                                ></div>
                                <span
                                  v-html="
                                    item.organ.split(';')[0] +
                                    (item.organ.split(';').length > 1
                                      ? ' ...'
                                      : '')
                                  "
                                ></span>
                              </el-tooltip>
                            </template>
                          </span>
                          <span class="o">
                            <template
                              v-if="item.theme && item.theme.length > 0"
                            >
                              <img src="~@/assets/images/icon-tag.png" />
                              <template v-for="(theme, index) in item.theme">
                                <span
                                  :key="index"
                                  v-html="theme"
                                  v-if="index < 2"
                                ></span>
                              </template>
                            </template>
                          </span>
                        </div>
                        <!-- <div class="hot">25486</div> -->

                        <div class="op">
                          <el-button
                            circle
                            icon="el-icon-close"
                            @click="handleRecommendClose(item)"
                          ></el-button>
                        </div>
                      </div>
                    </template>
                  </el-skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="picShow" width="1100px" class="report-picshow">
      <div class="intro">
        <img class="logo" src="@/assets/images/logo.svg" alt="" />
        <p>
          轻研智库全面覆盖各投资领域，依托海量的宏观策略、行业发展、上市公司等研究报告，采用智能搜索引擎、专业OCR识别、文档结构化解析、自然语言处理等技术，致力于为金融投资人员、企业高管、咨询顾问、行业研究员、市场分析师、市场运营人员等提供便捷、全面的实时、专业的信息检索服务。
        </p>
      </div>
      <div class="picshow">
        <el-carousel
          trigger="click"
          :autoplay="false"
          arrow="always"
          indicator-position="none"
          ref="carousel"
          @change="handleCarouselChange"
        >
          <el-carousel-item
            v-for="(item, index) in picReport.picList"
            :key="index"
          >
            <label v-if="item && item.title">
              {{ item.title.replace(/[图表]+?[\d-]{0,6}[:：\s\.]+/g, "") }}
            </label>
            <el-image :src="item.src"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="report-info">
        <div
          class="title"
          v-if="picReport && picReport.title"
          v-html="picReport.title.replace(/(<([^>]+)>)/gi, '')"
        ></div>
        <div class="info">
          <span class="t">
            <img src="~@/assets/images/icon-time.png" alt="" />
            {{ dateFormat(picReport.date, "YYYY-MM-DD") }}
          </span>
          <span
            class="o"
            v-if="picReport.institution && picReport.institution.length > 0"
          >
            <img src="~@/assets/images/icon-from.png" alt="" />
            <span
              v-for="(institution, index) in picReport.institution"
              :key="index"
              v-html="institution"
            ></span>
          </span>
          <span
            class="u"
            v-if="picReport.author && picReport.author.length > 0"
          >
            <img src="~@/assets/images/icon-user.png" alt="" />
            <el-tooltip placement="top" effect="light">
              <div slot="content" v-html="picReport.author.join(', ')"></div>
              <span
                v-html="
                  picReport.author[0] +
                  (picReport.author.length > 1 ? ' ...' : '')
                "
              ></span>
            </el-tooltip>
          </span>
          <span class="p" v-if="picReport.pages">
            <img src="~@/assets/images/icon-page.png" alt="" />
            {{ picReport.pages }}页
          </span>
        </div>
        <div class="bottom">
          <span class="type" v-if="picReport.industryFirst">
            {{ picReport.industryFirst }}
          </span>
          <span class="op">
            <el-button size="small" @click="downloadImg">
              <img src="~@/assets/images/icon-download.png" alt="" />
              下载
            </el-button>
          </span>
        </div>
      </div>
    </el-dialog>

    <FolderTreeDialog
      ref="folderTreeDialog"
      :folderTreeDialogType="folderTreeDialogType"
      :folderTreeDialogTitle="folderTreeDialogTitle"
      :currentNodeKey="currentNodeKey"
      :defaultExpandedKeys="defaultExpandedKeys"
      :folderTreeDialogId="folderTreeDialogId"
      @refreshData="getUserReportList"
    ></FolderTreeDialog>
  </div>
</template>

<script>
import VipHeaderCompose from "@/components/headerCompose.vue";
import ComposeLeft from "@/components/compose/left.vue";
import ComposeSearch from "@/components/compose/search.vue";
import FolderTreeDialog from "@/components/compose/folderTreeDialog.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { axiosOptions, axiosRequest } from "../../util/request";
import {
  delUserReport,
  cutstr,
  downloadReport,
  downloadDataIntelligenceImg,
} from "../../util/utils";
import moment from "moment";

export default {
  components: {
    VipHeaderCompose,
    ComposeLeft,
    ComposeSearch,
    FolderTreeDialog,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      loadingSkt: true,
      picSrc1: require("@/assets/images/sample-pic3.png"),
      picSrc2: require("@/assets/images/sample-pic4.png"),
      picSrc3: require("@/assets/images/sample-pic1.png"),
      picSrc4: require("@/assets/images/sample-pic2.png"),
      picSrc5: require("@/assets/images/sample-pic5.png"),
      picSwiper: {
        slidesPerView: 1,
        spaceBetween: 15,
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // },
        breakpoints: {
          "@0.00": {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          "@0.50": {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          "@0.75": {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          "@1.00": {
            slidesPerView: 4,
            spaceBetween: 15,
          },
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      picShow: false,
      picReport: {},
      picInfo: {},

      folderTreeDialogType: 0,
      folderTreeDialogTitle: "移动到",
      defaultExpandedKeys: [0],
      currentNodeKey: 0,
      folderTreeDialogId: 0,

      userReportLoading: false,
      userReportList: [],

      recommendLoading: false,
      recommendList: [],
      recommendPageIndex: 1,
      recommendPageCount: 5,
    };
  },
  created() {
    this.getUserReportList();
    this.getRecommendList();
  },
  watch: {
    "$route.query"(newQuery) {},
  },
  computed: {
    disabled() {
      return this.recommendLoading;
    },
  },
  methods: {
    handleCarouselChange(index, oldIndex) {
      this.picInfo = this.picReport.picList[index];
    },
    downloadImg() {
      downloadDataIntelligenceImg(this.picInfo.id, this.picInfo.title);
    },
    handlePicShow(item, index) {
      this.picReport = item;
      this.picShow = true;
      setTimeout(() => {
        this.$refs.carousel.setActiveItem(index);
      }, 1);
    },
    cutstring(str, len) {
      return cutstr(str, len);
    },
    clearHtml(val) {
      if (val) {
        return val.replace(/(<([^>]+)>)/gi, "");
      }

      return "";
    },
    recommendNextPage() {
      if (this.recommendPageIndex + 1 <= this.recommendPageCount) {
        this.recommendPageIndex++;
        this.getRecommendList();
      }
    },
    handleRecommendClose(data) {
      let removeIndex = this.recommendList.findIndex((i) => i === data);
      if (removeIndex > -1) {
        this.recommendList.splice(removeIndex, 1);
      }
    },
    getRecommendList() {
      this.recommendLoading = true;
      axiosRequest(
        "/user-report/recommend",
        { pageIndex: this.recommendPageIndex },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res.data && res.data.code === 200) {
            if (res.data.data && res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                this.recommendList.push(element);
              });
            } else {
              this.recommendPageIndex = this.recommendPageCount;
            }
          }
          this.recommendLoading = false;
        })
        .catch(() => {
          this.recommendLoading = false;
        });
    },
    handleDownload(id, title, suffix) {
      downloadReport(0, id, title, suffix);
    },
    handleDelUserReport(id) {
      delUserReport(id, 1)
        .then((res) => {
          if (res.data && res.data.code === 200) {
            let removeIndex = this.userReportList.findIndex((a) => a.id === id);
            if (removeIndex > -1) {
              this.userReportList.splice(removeIndex, 1);
            }
          }
        })
        .catch(() => {});
    },
    handleFolderTreeDialog(type, folderId, id) {
      switch (type) {
        case 0:
          this.folderTreeDialogTitle = "移动到";
          break;
        case 1:
          this.folderTreeDialogTitle = "复制到";
          break;
      }
      this.folderTreeDialogType = type;
      this.defaultExpandedKeys = [folderId];
      this.currentNodeKey = folderId;
      this.folderTreeDialogId = id;
      this.$refs.folderTreeDialog.show();
    },
    getUserReportList() {
      this.userReportLoading = true;
      axiosRequest(
        "/user-report/paged-list",
        {
          type: 0,
          listType: 0,
          pageIndex: 1,
          pageSize: 4,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          this.userReportLoading = false;
          if (res.data && res.data.code === 200) {
            this.userReportList = res.data.data.records;
          }
        })
        .catch(() => {
          this.userReportLoading = false;
        });
    },
    showTips() {
      this.$message.warning("功能开发中...");
    },
    cutstring(str, len) {
      return cutstr(str, len);
    },
    dateFormat(cellValue, format) {
      if (!cellValue) return "";
      return moment(cellValue).format(format);
    },
  },
  mounted() {},
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "@/assets/css/compose.scss";

::v-deep .article-list {
  .pic {
    .el-image {
      text-align: center;
      display: flex;
      align-items: center;
      text-align: center;

      img {
        cursor: pointer;
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        margin: 0 auto;
      }
    }
  }

  .picshow {
    .el-image {
      text-align: center;
      img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        margin: 0 auto;
      }
    }
  }
}

.report-picshow {
  ::v-deep {
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__headerbtn {
      top: 0;
      right: -50px;
      width: 50px;
      height: 50px;
      line-height: 55px;

      background-color: rgba(0, 0, 0, 0.5);
      i {
        font-size: 24px;
        color: #fff;
      }
    }
    .el-dialog__body {
      padding: 25px;
    }
  }
  .intro {
    position: relative;
    margin-bottom: 30px;
    padding: 15px 15px 15px 160px;
    font-size: 13px;
    line-height: 24px;
    color: #252b3a;
    background-color: #e7fafe;
    z-index: 1;
    &:after {
      position: absolute;
      top: -10px;
      right: -10px;
      bottom: -10px;
      left: -10px;
      background: url(~@/assets/images/picshow-arrow1.png) no-repeat left top,
        url(~@/assets/images/picshow-arrow2.png) no-repeat right top,
        url(~@/assets/images/picshow-arrow3.png) no-repeat right bottom,
        url(~@/assets/images/picshow-arrow4.png) no-repeat left bottom;
      z-index: -1;
      content: "";
    }
    .logo {
      position: absolute;
      left: 15px;
      top: 15px;
      height: 46px;
    }
  }
  .picshow {
    ::v-deep {
      .el-carousel__container {
        height: 457px;
      }
      .el-carousel__arrow {
        margin-top: 26px;
      }
      .el-carousel__arrow--left {
        left: 0;
      }
      .el-carousel__arrow--right {
        right: 0;
      }
    }
    label {
      display: block;
      margin-bottom: 20px;
      font-size: 24px;
      line-height: 32px;
      @include clips(1);
    }
    .el-image {
      width: 100%;
      height: 400px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.08);
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .report-info {
    padding-top: 10px;
    .title {
      margin-bottom: 10px;
      font-size: 18px;
      line-height: 32px;
    }
    .info {
      margin-bottom: 15px;
      font-size: $fontSizeSmall;
      color: $colorFontSub;
      > span {
        img {
          height: 16px;
          margin-right: 3px;
          vertical-align: -3px;
        }
        + span {
          margin-left: 40px;
        }
      }
      .o {
        span + span {
          margin-left: 25px;
        }
      }
    }
    .bottom {
      display: flex;
      margin-bottom: -15px;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;
      border-top: 1px solid #d3d5d8;
      .type {
        height: 32px;
        margin-right: 15px;
        padding: 0 15px;
        line-height: 30px;
        font-size: 14px;
        background-color: #fde1dc;
        border: 1px solid #fdc4b9;
        border-radius: 20px;
        white-space: nowrap;
      }
      .el-button {
        height: 30px;
        padding: 0px 15px;
        font-size: $fontSize;
        line-height: 30px;
        border-radius: 20px;
        vertical-align: top;
        img {
          margin-right: 5px;
          vertical-align: -3px;
        }
      }
    }
  }
}
</style>
